import { action, observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { toast } from "react-toastify";
import { toast_error } from "../../utils";

export class _EanStore {

  obs = observable({
    eans_paginate: [] as any[],
    totalRows: 0 as number,
    currentPage: 1 as number,
    loading_eans: false as boolean,
    filter: "" as string
  })

  async handldeFilterEans(filtro: string, page: number) {

    try {

      this.obs.loading_eans = true

      let params = {
        text: filtro,
        paged: page,
        limit: 50
      }

      let resp = await apiOperacao("legislacoes").post(`/legislacoes/filter-eans`, params)

      this.obs.eans_paginate = [];
      this.obs.totalRows = 0;
      this.obs.eans_paginate = resp.data.itens
      this.obs.totalRows = resp.data.count

    } catch (ex) {
      toast_error(ex, `Erro ao filtar Eans, tente novamente mais tarde.`);
    }

    this.obs.loading_eans = false

  }

}

export const EanStore = new _EanStore();
